// extracted by mini-css-extract-plugin
export default {"summaryContent":"component-styles_summaryContent__BWgbr","item":"component-styles_item__hsusV"};